function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Button } from 'reactstrap';
import styled from 'styled-components';
import FontAwesome from 'react-fontawesome';
import Theme from '../modules/Theme';
var sizes = {
  large: '160px',
  small: '80px'
};
var iconFontSizes = {
  large: '122px',
  small: '61px'
};
var RoundedButton = styled(function (_ref) {
  var color = _ref.color,
      passThroughProps = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React.createElement(Button, passThroughProps);
}).withConfig({
  displayName: "RoundButton__RoundedButton",
  componentId: "sc-255cjt-0"
})(["border-radius:50%;width:", ";height:", ";font-size:110%;word-wrap:break-word;white-space:initial;margin:5px 10px;background-color:", ";box-shadow:0 0 10px rgba(0,0,0,0.5);color:white;position:relative;font-weight:700;cursor:pointer;"], function (props) {
  return sizes[props.size] || sizes['large'];
}, function (props) {
  return sizes[props.size] || sizes['large'];
}, function (props) {
  return props.color ? Theme[props.color] : null;
});

var RoundButton = function RoundButton(_ref2) {
  var children = _ref2.children,
      icon = _ref2.icon,
      passThroughProps = _objectWithoutProperties(_ref2, ["children", "icon"]);

  var size = passThroughProps.size || 'large';
  return /*#__PURE__*/React.createElement(RoundedButton, passThroughProps, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      lineHeight: sizes[size],
      fontSize: iconFontSizes[size],
      top: '0',
      left: '0',
      color: 'rgba(255,255,255,0.2)'
    }
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    fixedWidth: true,
    name: icon
  })), children);
};

RoundButton.defaultProps = {
  size: 'large'
};
export default RoundButton;